module.exports = __webpack_public_path__ + "static/media/MasterLogoWhite.54b46b25.png";